import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import Text from '../Text';

interface TooltipProps {
  title: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const TooltipWeb = ({ title, children, onClick }: TooltipProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      onClick={() => {
        onClick && onClick();
        setVisible(!visible);
      }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      style={styles.container}>
      {children}
      {visible && (
        <Animated.View entering={FadeIn} exiting={FadeOut} style={[styles.tooltip]}>
          <Text style={styles.tooltipText}>{title}</Text>
        </Animated.View>
      )}
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center'
  },

  tooltip: {
    overflow: 'visible',
    position: 'absolute',
    alignSelf: 'center',
    bottom: '35%',
    transform: [{ translateX: 24 }],
    backgroundColor: '#EDEDED',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 6,
    zIndex: 9999
  },

  tooltipText: {
    flex: 1,
    color: 'black',
    fontSize: 14,
    flexShrink: 1,
    flexWrap: 'wrap',
    textAlign: 'left'
  }
});

export default TooltipWeb;
